import React from 'react';

const RWAExplanation = () => {
  return (
    <section className="rwa-explanation" id="rwa-explanation">
      <div className="container">
        <div className="glass-card">
          <h2 className="section-title">What are <span>RWA</span> Packages?</h2>
          <p>Real World Assets (RWA) packages are physical WiFi devices that bridge the gap between tangible hardware and Web3 rewards. Each AeroFi device serves as a mining node in our ecosystem, earning AFI tokens while providing high-speed global connectivity.</p>
          
          <div className="highlight-box">
            <h4>Why AeroFi RWA Devices are Revolutionary:</h4>
            <p>Unlike traditional mining that requires massive energy consumption, AeroFi devices utilize AI-enhanced connectivity to generate rewards while serving a practical purpose - providing fast, reliable internet access anywhere in the world.</p>
          </div>
          
          <div className="warning-box">
            <h4>Understanding Token-Denominated Returns</h4>
            <p>All returns are calculated in AFI tokens, not USD value. This means that while APY percentages remain consistent in token terms, the actual USD value of your returns will fluctuate with the market price of AFI. This approach provides system stability but requires understanding that high token-denominated APYs do not guarantee equivalent USD returns.</p>
          </div>
          
          <div className="feature-list">
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#6366F1" strokeWidth="2"/>
                  <path d="M7.5 12H16.5" stroke="#6366F1" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M12 6.5V17.5" stroke="#6366F1" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <div className="feature-content">
                <h4>Dual Utility</h4>
                <p>Each device provides practical WiFi connectivity while simultaneously mining AFI tokens, creating a dual value proposition regardless of market conditions.</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 7L12 3L4 7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4 7V17L12 21L20 17V7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 11L20 7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 11V21" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 11L4 7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="feature-content">
                <h4>Enhanced Staking</h4>
                <p>Boost your mining rewards by staking AFI tokens alongside your device, unlocking higher yield tiers through our multi-level enhancement system.</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 9V3H15" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3 15V21H9" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M21 3L14 10" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10 14L3 21" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="feature-content">
                <h4>Temporal Advantage</h4>
                <p>Our new reward mechanism prioritizes early adopters, ensuring those who join first maintain a permanent advantage in the ecosystem.</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 5L19 9L15 13" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M19 9H5" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8 19L4 15L8 11" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4 15H18" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="feature-content">
                <h4>Sustainable Tokenomics</h4>
                <p>Our carefully balanced token model with fixed supply and emission schedule ensures long-term value protection through systematic burning.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RWAExplanation;
